export default {
  subject: {
    presence: {
      allowEmpty: false,
      message: "is required"
    }, 
    length: {
      minimum: 3,
      message: "is too short"
    }
  },
  message: {
    presence: {
      allowEmpty: false,
      message: "is required"
    },
    length: {
      minimum: 5,
      message: "is too short"
    }
  },
  email: {
    presence: false,
    email: {
      message: "is not a valid email",
    }
  }
};